// Where the connection stands, for the Settings section: one small external
// store (`useSyncExternalStore` reads it) and the status line's words. Pure.

export type CoachStatus = { kind: 'off' } | { kind: 'disconnected'; reason: string } | { kind: 'connecting' } | { kind: 'connected'; since: number };

export class StatusStore {
  private state: CoachStatus = { kind: 'off' };
  private readonly listeners = new Set<() => void>();

  get(): CoachStatus {
    return this.state;
  }

  set(next: CoachStatus): void {
    this.state = next;
    for (const l of this.listeners) l();
  }

  subscribe(listener: () => void): () => void {
    this.listeners.add(listener);
    return () => void this.listeners.delete(listener);
  }
}

/** "hh:mm" in the reader's locale, 24-hour where the locale is. */
export function clockTime(epochMs: number, locale?: string): string {
  return new Date(epochMs).toLocaleTimeString(locale, { hour: '2-digit', minute: '2-digit' });
}

/** The status line: Off / Not connected · reason / Connecting… / Connected · since hh:mm. */
export function statusText(status: CoachStatus, time: (epochMs: number) => string = clockTime): string {
  switch (status.kind) {
    case 'off':
      return 'Off';
    case 'disconnected':
      return `Not connected · ${status.reason}`;
    case 'connecting':
      return 'Connecting…';
    case 'connected':
      return `Connected · since ${time(status.since)}`;
  }
}
